import React from "react";
import { Html5Entities } from "html-entities";

function HeaderMenuItem(props) {
    const htmlEntities = new Html5Entities();
  //console.log('props in HeaderMenuItem: ', props);
  return (    
        <li>
          <a className="dropdown-item" href="#index">
              <img style={{ width: 150 }} src={htmlEntities.decode(props.data.img_path)} alt=""/>
            { /*props.data.text*/ }
          </a>
        </li>    
  );
}

export default HeaderMenuItem;
